import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { SignupAccessService } from '../services/signup-access.service';

@Injectable({
  providedIn: 'root',
})
export class SignupAccessGuard {
  private signupAccessService = inject(SignupAccessService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    if (route.queryParams.invitee_uuid) {
      return true;
    }
    if (this.signupAccessService.isSignupAllowed()) {
      return true;
    }
    return this.router.createUrlTree(['/login']);
  }
}
